'use client';

import { faEnvelope, faRankingStar, faReceipt, faScreenUsers } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from '@pickleballinc/react-ui';
import { MenuItem } from '@pickleballinc/react-ui/Menu/MenuItem';

import SVGMyLeaguesIcon from '@/components/atoms/SVGMyLeaguesIcon';

interface ProfileDropdownMenu {
	isCaptain?: boolean;
}

export const ProfileDropdownMenu = ({ isCaptain }: ProfileDropdownMenu) => {
	const menuItemStyle =
		'h-11 cursor-pointer rounded-md py-2.5 pl-2 pr-2.5 text-base font-medium leading-6 text-gray-900 !outline-none hover:bg-purple-100';

	return (
		<>
			<Menu.List className="w-[300px] rounded-lg border-none">
				<MenuItem onClick={() => {}} className={`${menuItemStyle}`} icon={<SVGMyLeaguesIcon />}>
					My leagues
				</MenuItem>
				<MenuItem
					onClick={() => {}}
					className={`${menuItemStyle}`}
					icon={<FontAwesomeIcon icon={faScreenUsers} width="24" className="text-gray-500" />}
				>
					My teams
				</MenuItem>
				<MenuItem
					onClick={() => {}}
					className={`${menuItemStyle}`}
					icon={<FontAwesomeIcon icon={faRankingStar} width="24" className="text-gray-500" />}
				>
					My stats
				</MenuItem>
				{!isCaptain && (
					<MenuItem
						onClick={() => {}}
						className={`${menuItemStyle}`}
						icon={<FontAwesomeIcon icon={faEnvelope} width="24" className="text-gray-500" />}
					>
						Contact captain
					</MenuItem>
				)}
				<MenuItem
					onClick={() => {}}
					className={`${menuItemStyle}`}
					icon={<FontAwesomeIcon icon={faReceipt} width="24" className="text-gray-500" />}
				>
					My transactions
				</MenuItem>
			</Menu.List>
		</>
	);
};
